export const messages = {
  ERROR_RESPONSE: 'common:error-fetch',
  SUCCESS: 'common:success-add',
  SUCCESS_LOGIN: 'common:success-login',
  SUCCESS_UPDATE: 'common:success-update',
};
